export default __webpack_public_path__ + "static/media/ai3.49038603.png";